import { render, staticRenderFns } from "./ScrollToTopBtn.vue?vue&type=template&id=1ef82817&scoped=true&"
import script from "./ScrollToTopBtn.vue?vue&type=script&lang=js&"
export * from "./ScrollToTopBtn.vue?vue&type=script&lang=js&"
import style0 from "./ScrollToTopBtn.vue?vue&type=style&index=0&id=1ef82817&lang=css&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ef82817",
  null
  
)

export default component.exports